// client/src/locales/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Bundle both supported languages to ensure instant switching
// The size increase is minimal compared to UX improvement
import translationKA from './ka/translation.json';
import translationEN from './en/translation.json';

const resources = {
  ka: { translation: translationKA },
  en: { translation: translationEN },
};

// Normalize language codes to base language (en-US → en, ka-GE → ka)
function normalizeLanguageCode(code) {
    if (!code) return 'ka'; // Default fallback
    const normalized = code.toLowerCase().split('-')[0];
    // Only allow supported languages
    return normalized === 'en' ? 'en' : 'ka';
}

// Language detector configuration
const detectionOptions = {
    // Allow deep links to set language via query first,
    // then fall back to previously saved localStorage preference
    order: ['querystring', 'localStorage'],

    // Querystring key to detect language from deep links (e.g., ?lang=en)
    lookupQuerystring: 'lang',

    // Keys to look for in localStorage
    lookupLocalStorage: 'telo_language_preference',

    // Cache user language preference
    caches: ['localStorage'],

    // Exclude cookie storage
    excludeCacheFor: ['cimode'],

    // Convert detected language codes to base (no regional variants)
    convertDetectedLanguage: normalizeLanguageCode
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ka',
    supportedLngs: ['ka', 'en'],
    debug: process.env.NODE_ENV === 'development',
    detection: detectionOptions,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

// Sync HTML lang attribute on language change
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

// Set initial HTML lang attribute
document.documentElement.lang = i18n.language;

export default i18n;
